import SearchInput from "./SearchInput";
import { UL } from "../../../AbstractElements";
import DarkMode from "./DarkMode/DarkMode";
import ResponsiveSearch from "./ResponsiveSearch";
import NotificationHeader from "./NotificationHeader/NotificationHeader";
import MessagesHeader from "./MessagesHeader/MessagesHeader";
import UserProfile from "./UserProfile/UserProfile";
import ZoomInOut from "./ZoomInOut/ZoomInOut";
import Language from "./Language/Language";
import HeaderBookmark from "./HeaderBookmark/HeaderBookmark";
import HeaderCart from "./HeaderCart/HeaderCart";

const MainHeader = () => {
  return (
    <>
      <SearchInput />
      <div className="nav-right col-auto pull-right right-header p-0 ms-auto">
        <UL className="nav-menus flex-row simple-list">
          <ResponsiveSearch />
          <ZoomInOut /> 
          <NotificationHeader />
          <HeaderBookmark />
          <MessagesHeader />
          <HeaderCart />
          <DarkMode />
          <Language />
          <UserProfile />
        </UL>
      </div>
    </>
  );
};

export default MainHeader;
